import { render, staticRenderFns } from "./DashboardWelcome.vue?vue&type=template&id=8190e84c&"
import script from "./DashboardWelcome.vue?vue&type=script&lang=js&"
export * from "./DashboardWelcome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports